<template>
<div>
<div class="g_dialogw" :class="{'g_dialogw_active': showStarEditPanel}"></div>
<div class="stareditpanel g_panel g_dialog"  ref="panelwrapper" :class="{'darkmode': darkMode}"  @click.stop>
  <!-- header -->
  <div class="header g_panel-header">
    <!-- <span class="back icon-back" role="button" aria-label="返回" tabindex="0" @click.stop="togglePanel()" /> -->
    <div class="close icon-del" role="button" aria-label="back" tabindex="1" @click.stop="togglePanel"></div>
    <h1 class="title">
      {{$t('editPanel.titleEdit')}}
      <!-- {{this.type === 'content' ? '添加分类' : '修改分类'}} -->
    </h1>
  </div>
  <!-- end header -->
  <!-- toobar -->
  <div class="toolbar" ref="tooBar" >
    <p class="toolbar-title">
      {{$t('editPanel.inputTip')}}
    </p>
    <div class="toolbar-inputw g_clearfix_after">
      <div class="toolbar-tagsw" role="button" :aria-label="$t('editPanel.inputwAria')" tabIndex="0" @click="inputFoucs">
        <div v-tip.dark="$t('editPanel.githubTagTip')" v-for="tag in githubTags" :key="tag._id" class="toolbar-tag toolbar-tag_github">
          {{tag.name}}
        </div>
        <div v-for="(tag, index) in tagSelected" :key="index" class="toolbar-tag">
          <img :src="tag.icon ? `${HttpRoot}${tag.icon}` : iconSrcDefault" class="toolbar-tag-icon" alt="">
          {{tag.name}}
          <span class="toolbar-tag-new" v-if="tag.type === 'new' || tag.type === 'recommend'"></span>
          <span
            class="toolbar-clear icon-del"
            @click="delTag(tag, index)"
            role='button'
            aria-label='delete'
            tabIndex="0"
          ></span>
        </div>
        <input
            class="toolbar-input"
            type='text'
            v-model="newTagName"
            :placeholder="$t('editPanel.inputPlaceholder')"
            @input="onInput"
            @keydown.delete="delTag()"
            ref="toolBarInput"
          />
        <!-- 输入提示 -->
        <!-- <ul class="toolbar-inputtip g_scroll" ref="inputTips">
          <li
            v-for="(tag, index) in inputTips"
            :key="tag._id"
            class="toolbar-inputtip-item"
            :class="{'toolbar-inputtip-item_active' : inputTipIndex === (index + 1)}"
          >

            <div
              role='button'
              class="tag"
              :aria-label="`choose：${tag.name}`"
              :tabIndex="0"
              @click="addTag(tag)"
            >
              <img class="tag-icon" :src="tag.icon || iconSrcDefault" alt="">
              {{tag.name}}
            </div>
          </li>
        </ul> -->
        <!-- end 输入提示 -->
      </div>
      <Btn
        :loading="editTaging"
        class="toolbar-confirm"
        @click.native="editStarTag"
        :class="{'toolbar-confirm_loading': editTaging, 'icon-ok': !editTaging }"
      />
    </div>
  </div>
  <!-- end toobar -->
  <!-- list -->
  <div class="listw g_scroll" ref="tagList">
    <div class="tag tag_create" :class="{tag_create_choose: tagChooseRecommendIndex === 0 && tagChooseLocalIndex === 0}" @click="addTag()" v-if="newTagName !== ''">
      <span class="icon icon-add"  />
      {{$t('editPanel.createNewTag', {name: `『${newTagName}』`})}}
    </div>
    <Loading v-if="showStarEditPanel && loading"></Loading>
    <ul class="list" v-if="tagsRecommendFilter.length && !loading">
      <h2 class="list-title">{{$t('editPanel.recommend')}}</h2>
      <li
          v-for="(tag, index) in tagsRecommendFilter"
          class="tag"
          :class="{tag_active: tagChooseRecommendIndex - 1 === index}"
          :key="index"
          @click="toggleChoseTag(tag)"
          role='button'
          :aria-label="tag.name"
          tabIndex="0"
      >
        <span class="tag-add" :class="{'icon-ok tag_choose': tag.hasChoose, 'icon-add': !tag.hasChoose}" />
        <img alt='icon' :src="iconSrcDefault" class="tag-icon" />
        <span class="tag-name g_textoverflow">
          {{tag.name}}
          <span class="icon icon-new tag-icon-new" v-if="tag.hasChoose"></span>
        </span>
      </li>
    </ul>
    <ul class="list" v-if="!loading">
      <h2 class="list-title">{{$t('editPanel.myCollections')}}</h2>
      <li class="tag"
          :class="{tag_active: tagChooseLocalIndex - 1 === index}"
          v-for="(tag, index) in starTagsFilter"
          :key="tag._id"
          @click="toggleChoseTag(tag)"
          role='button'
          :aria-label="tag.name"
          tabIndex="0"
      >
        <span class="tag-add" :class="{'icon-ok tag_choose': tag.hasChoose, 'icon-add': !tag.hasChoose}" />
        <img alt='icon' :src="tag.type === 'new' ? iconSrcDefault : `${HttpRoot}${tag.icon}`" class="tag-icon" />
        <span class="tag-name g_textoverflow">
          {{tag.name}}
          <span class="icon icon-new tag-icon-new" v-if="tag.type === 'new'"></span>
        </span>
      </li>
    </ul>
    <!-- <ul class="list list_github">
      <h2 class="list-title">Github默认分类（不可修改）</h2>
      <li class="tag"
          v-for="tag in githubTags"
          :key="tag._id"
          role='button'
          :aria-label="`分类：${tag.name}`"
          tabIndex="0"
      >
        <span class="tag-add" :class="{'icon-ok tag_choose': tag.hasChoose, 'icon-add': !tag.hasChoose}" />
        <img alt='图标' :src="tag.type === 'new' ? tag.icon : `${HttpRoot}${tag.icon}`" class="tag-icon" />
        <span class="tag-name g_textoverflow">{{tag.name}}</span>
      </li>
      </ul> -->
    </div>
  </div>
  <!-- end list -->

</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Loading'
import Btn from '@/components/Btn'
import { HttpRoot } from '@/config'
import { updateContentPage } from '@/util/chrome.api'

export default {
  components: {
    Loading,
    Btn,
  },
  data() {
    return {
      newTagName: '',
      hide: true,
      starId: '', // id有两种获取方式，所以还有一个prop id
      show: false,
      editTaging: false,
      loading: false,
      HttpRoot,
      inputTips: [],
      tagsRecommendFilter: [],
      starTagsFilter: [],
      tagsRecommend: [],
      tagsRecommendMap: {},
      githubTags: [], // github默认tag
      inputTipIndex: 0, // 选择的提示index
      tagLocalIdsOrigin: [], // 未编辑前star的local tagids
      tagsLocalOrigin: [], // 为编辑前，star原来的local tags
      starTags: [], // 老的tag
      tagSelected: [], // 选择的所有tag
      iconSrcDefault: require('@/assets/icon_default.png'),
      tagChooseRecommendIndex: 0, // 上下选择的index（后期再加）
      tagChooseLocalIndex: 0,
      editType: 'single', // 编辑类型，single or  multi
    }
  },
  computed: {
    // tagsRecommendComp() {
    //   return this.tagsRecommend.filter((tag) => {
    //     return !tag.hide
    //   })
    // },
    // starTagsComp() {
    //   return this.starTags.filter((tag) => {
    //     return !tag.hide
    //   })
    // },
    ...mapState({
      stars: state => state.star.stars,
      tags: state => state.star.tags,
      showStarEditPanel: state => state.starEdit.showPanel,
      repo: state => state.starEdit.repo,
    }),
  },
  watch: {
    /**
     * 在cotent页面的显示
     */
    showStarEditPanel(val) {
      if (val) {
        setTimeout(() => {
          document.addEventListener('click', this.togglePanel, false)
          document.addEventListener('keydown', this.onkeyEvent, false)
        }, 0)
        this.initData()
        this.setOnEventPanel('starEditPanel')
        setTimeout(() => {
          this.$refs.toolBarInput.focus()
        }, 100)
      } else {
        this.setOnEventPanel('tagList')
        document.removeEventListener('click', this.togglePanel)
        document.removeEventListener('keydown', this.onkeyEvent)
        this.dataReset()
      }
    },
  },
  methods: {
    ...mapActions({
      getRepoInfo: 'star/getRepoInfo',
      initDatas: 'star/initDatas',
      editStar: 'star/editStar',
      newStar: 'star/newStar',
      editMultiStar: 'star/editMultiStar',
    }),
    ...mapMutations({
      setOnEventPanel: 'event/setOnEventPanel',
      togglePanel: 'starEdit/togglePanel',
    }),
    scrollHeight() {
      const createTagHeihgt = this.newTagName !== '' ? 35 : 0
      const listHeihgt = this.$refs.tagList.offsetHeight - 6
      const tagIndex = this.tagChooseLocalIndex > 0
        ? (this.tagsRecommendFilter.length + this.tagChooseLocalIndex)
        : this.tagChooseRecommendIndex
      const titleHeight = this.tagsRecommendFilter.length > 0 ? 56 : 28
      this.$refs.tagList.scrollTop = parseInt((createTagHeihgt + titleHeight + tagIndex * 32) / listHeihgt) * listHeihgt - 16
    },
    onkeyEvent(e) {
      // 下
      if (e.key === 'ArrowDown' || e.keyCode === 40) {
        if (this.tagChooseRecommendIndex < this.tagsRecommendFilter.length && this.tagChooseLocalIndex === 0) {
          this.tagChooseRecommendIndex += 1
        } else if (this.tagChooseLocalIndex < this.starTagsFilter.length) {
          this.tagChooseLocalIndex += 1
          this.tagChooseRecommendIndex = 0
        }

        this.scrollHeight()
      }
      // 上
      if (e.key === 'ArrowUp' || e.keyCode === 38) {
        if (this.tagChooseLocalIndex > 0) {
          this.tagChooseLocalIndex -= 1
          if (this.tagChooseLocalIndex === 0 && this.tagsRecommendFilter.length) {
            this.tagChooseRecommendIndex = this.tagsRecommendFilter.length
          }
        } else if (this.tagChooseRecommendIndex > 0) {
          this.tagChooseRecommendIndex -= 1
          this.tagChooseLocalIndex = 0
        }
        if (this.tagChooseLocalIndex === 0 && this.tagChooseRecommendIndex === 0) {
          this.$refs.toolBarInput.focus()
        }

        this.scrollHeight()
      }

      // enter
      if (e.key === 'Enter' || e.keyCode === 13) {
        if (this.tagChooseLocalIndex > 0 || this.tagChooseRecommendIndex > 0) {
          const tag = this.tagChooseLocalIndex > 0
            ? this.starTagsFilter[this.tagChooseLocalIndex - 1] : this.tagsRecommendFilter[this.tagChooseRecommendIndex - 1]
          if (tag.hasChoose) {
            this.delTag(tag)
          } else {
            this.addTag(tag)
          }
        } else if (this.newTagName) {
          this.addTag()
        } else {
          this.editStarTag()
        }
      }

      // esc
      if (e.key === 'Escape' || e.keyCode === 27) {
        if (this.tagChooseLocalIndex > 0 || this.tagChooseRecommendIndex > 0) {
          this.tagChooseLocalIndex = 0
          this.tagChooseRecommendIndex = 0
        } else {
          this.togglePanel()
        }
      }
    },
    /**
     * initData
     */
    initData() {
      // 多个项目的编辑
      if (this.repo && this.repo.length) {
        this.dataReset()
        this.editType = 'multi'
        this.initTags()
      } else {
        const promise = this.getRecommendTags()
        if (promise) {
          promise.then(() => {
            this.tagsListReset()
            this.initTags()
          })
        }
      }
    },
    /**
     * 推荐tag 列表清空
     */
    tagsRecommendReset() {
      this.tagsRecommend = []
      this.tagsRecommendMap = {}
      this.tagsRecommendFilter = []
    },
    /**
     * 其他相关的tag 列表清空
     */
    tagsListReset() {
      this.githubTags = [] // github默认tag

      this.tagLocalIdsOrigin = [] // 未编辑前star的local tagids
      this.tagsLocalOrigin = [] // 未编辑前，star原来的local tags

      this.starTags = [] // 老的tag

      this.tagSelected = [] // 所有刚选择的或新创建的tag

      this.tagChooseRecommendIndex = 0
      this.tagChooseLocalIndex = 0
      this.starTagsFilter = []
      // this.inputTips = []
      // this.inputTipIndex = 0 // 选择的提示index
    },
    /**
     * datareset
     */
    dataReset() {
      this.tagsRecommendReset()
      this.tagsListReset()
      this.newTagName = ''
      this.editType = 'single'
    },
    /**
     * 获取推荐的tag
     */
    getRecommendTags() {
      const fullName = this.fullName || (this.stars[this.repo.id] && this.stars[this.repo.id].full_name)
      if (!fullName) {
        return
      }
      this.loading = true
      const req = this.$http.get(`/star/${fullName}/recommend`, {}, {
        requestId: 'recommendTags',
      })
      return req.then((res) => {
        // 重置一下推荐tag的list，因为可能会重复打开弹窗导致list重复
        this.tagsRecommendReset()
        res.recommendTags.forEach((item, index) => {
          this.tagsRecommend.push({
            type: 'recommend',
            name: item,
          })
          this.tagsRecommendMap[item] = true
        })
        // this.tagsRecommendFilter = this.tagsRecommend
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onBlur() {
      this.inputTips = []
    },
    /**
     * 初始化tags，自己创建的tag，以及github默认的tag
     */
    initTags() {
      const tagIds = (this.editType !== 'multi' && this.stars[this.repo.id] && this.stars[this.repo.id].tags) || []
      this.tagLocalIdsOrigin = tagIds
      const localTags = []
      this.tags.forEach((tag) => {
        const hasChoose = tagIds.includes(tag._id)
        const tagCopy = Object.assign({}, {}, tag)

        if (hasChoose) {
          tagCopy.hasChoose = true
        }

        // 推荐过滤有相同名字的
        if (this.tagsRecommendMap[tag.name]) {
          this.tagsRecommend = this.tagsRecommend.filter((item) => item.name !== tag.name)
          this.tagsRecommendFilter = this.tagsRecommend
        }

        // 要让github的tag放在数组最前面
        if (tag.type === 'github' && hasChoose) {
          this.githubTags.push(tagCopy)
        }

        if (tag.type !== 'github' && tag.type !== 'local_statistics') {
          if (hasChoose) {
            this.tagsLocalOrigin.push(tagCopy)
            this.tagSelected.push(tagCopy)
          }
          localTags.push(tagCopy)
        }
      })

      this.starTags = localTags.sort((tagA, tagB) => {
        return new Date(tagB.created_at).getTime() - new Date(tagA.created_at).getTime()
      })
      this.starTagsFilter = this.starTags
    },
    async star() {
      this.loading = true

      const reqData = {
        body: {
          tagsAdd: [],
        },
      }

      reqData.body.fullName = this.fullName
      reqData.body.repoInfo = this.repo

      const tagsAll = this.tags.filter(tag => (tag.name === '所有项目' && tag.type === 'local_statistics'))
      if (tagsAll && tagsAll[0]) reqData.body.tagsAdd.push(tagsAll[0])
      if (!(this.repo && this.repo.language)) {
        const tagsNo = this.tags.filter(tag => (tag.name === '未分类' && tag.type === 'local_statistics'))
        if (tagsNo & tagsNo[0]) reqData.body.tagsAdd.push(tagsNo[0])
      }
      return this.newStar(reqData).then((res) => {
        this.loading = false
        this.$emit('refresh')
        this.repo.id = res.star.id
        // 更新数据
        this.initDatas('content')
      }).catch((err) => {
        if (this.type === 'content' && err.type !== 'githubReq') this.$emit('hide')
        if (err.msg && err.type !== 'githubReq') {
          this.$toast({
            msg: err.msg,
          })
        }
      })
    },
    editStarTag() {
      if (this.editType === 'single') {
        this.editSingleTag()
      } else {
        this.editMultiTag()
      }
    },
    /**
     * 编辑多个项目
     */
    editMultiTag() {
      this.editTaging = true
      const tagsNew = []
      const tagsAdd = []

      this.tagSelected.forEach((tag, index) => {
        if (tag.type === 'new') tagsNew.push(tag)
        if (tag.type === 'local') tagsAdd.push(tag)
      })

      if (!tagsNew.length && !tagsAdd.length) {
        this.togglePanel()
        this.editTaging = false
        return
      }

      this.editMultiStar({
        tagsNew,
        tagsAdd,
        stars: this.repo,
      }).then(() => {
        this.$toast({
          msg: this.$i18n.t('starsPanel.editTip'),
          duration: 1000,
        })
        this.togglePanel()
        this.$emit('refresh')
      }).finally(() => {
        this.editTaging = false
      })
    },
    /**
     * 编辑单个项目
     */
    editSingleTag() {
      const tagsChoose = [] // 原来已经创建并且选择的tag
      const tagsNew = [] // 原来还没创建，需要重新创建的tag
      let tagsDel = this.tagsLocalOrigin // 原来选择了，这次去除的tag
      const selectTags = []
      this.tagSelected.forEach((tag, index) => {
        selectTags.push(tag)
        // 得到新添加的tag
        if (tag.type === 'new') tagsNew.push(tag)
        if (tag.type === 'local') {
          // 如果是已创建的tag，并且原来没有选择改tag
          if (!this.tagLocalIdsOrigin.includes(tag._id)) {
            tagsChoose.push(tag)
          // 如果是原来就已经选择的tag，在tagsLocalOrigin里面过滤掉该tag，最后剩下的就是删除的tag
          } else {
            // 过滤掉还在的的tag，获取删除的tag
            tagsDel = tagsDel.filter((tagOrigin) => tagOrigin._id !== tag._id)
          }
        }
      })

      // 将推荐的tag也放到tagsNew
      this.tagsRecommend.forEach((tag) => {
        if (tag.hasChoose) {
          selectTags.push(tag)
          tagsNew.push(tag)
        }
      })

      // 如果没有选择自定义的tag，那么这个star要放到未分类里面
      if (!selectTags.length && this.tagsLocalOrigin.length) {
        tagsChoose.push(this.tags.filter((tag) => { return (tag.name === '未分类' && tag.type === 'local_statistics') })[0])
      }

      // 如果原来没有分类，现在有选择分类，那么要从未分类的tag里面删除
      if (this.repo.id && !this.tagsLocalOrigin.length && selectTags.length
      ) {
        tagsDel.push(this.tags.filter((tag) => {
          return (tag.name === '未分类' && tag.type === 'local_statistics')
        })[0])
      }

      // 如果没有tagsAdd, tagsNew，但是有输入，则创建一个新的tag
      if (!selectTags.length && !this.tagsLocalOrigin.length && this.newTagName) {
        tagsNew.push({
          name: this.newTagName,
          type: 'new',
        })
      }

      const reqData = {
        body: {
          fullName: this.fullName,
          tagsAdd: tagsChoose,
          tagsNew,
          tagsDel,
        },
      }

      this.editTaging = true
      reqData.body.star = this.stars[this.repo.id]

      if (!tagsChoose.length && !tagsNew.length && !tagsDel.length) {
        this.togglePanel()
        this.editTaging = false
        return
      }
      this.editStar(reqData).then(() => {
        this.editTaging = false
        this.$toast({
          msg: this.$i18n.t('starsPanel.editTip'),
          duration: 1000,
        })
        this.show = false
        this.togglePanel()
        this.$emit('refresh')
        if (this.type !== 'content') {
          updateContentPage({ update: true })
        }
      }).catch((err) => {
        if (this.type === 'content') {
          this.$toast({
            msg: err.msg || this.$i18n.t('starsPanel.serverErr'),
          })
        }
        this.editTaging = false
      })
    },
    inputFoucs() {
      this.$refs.toolBarInput.focus()
    },
    // onFocus() {
    //   document.addEventListener('keydown', this.chaneInputIndex, false)
    // },
    // onBlur() {
    //   document.removeEventListener('keydown', this.chaneInputIndex)
    // },
    chaneInputIndex(e) {
      // 下
      if (e.keyCode === 40) {
        e.preventDefault()
        // this.$refs.toolBarInput.blur()
        if (this.inputTipIndex < this.inputTips.length) {
          this.inputTipIndex += 1
        }
        this.$refs.inputTips.scrollTop = parseInt((this.inputTipIndex - 1) / 6) * 24 * 6
      }
      // 上
      if (e.keyCode === 38) {
        e.preventDefault()
        if (this.inputTips.length >= 1 && this.inputTipIndex > 0) {
          this.inputTipIndex -= 1
        }
        this.$refs.inputTips.scrollTop = parseInt((this.inputTipIndex - 1) / 6) * 24 * 6
        if (this.inputTipIndex === 0) {
          this.$refs.toolBarInput.focus()
          setTimeout(() => {
            this.$refs.toolBarInput.setSelectionRange(-1, -1)
          }, 10)
        }
      }

      // esc
      if (e.keyCode === 27) {
        this.inputTips = []
        this.$refs.toolBarInput.focus()
        setTimeout(() => {
          this.$refs.toolBarInput.setSelectionRange(-1, -1)
        }, 10)
      }
    },
    /*
    * 监听input
    */
    onInput(e) {
      this.inputTipIndex = 0
      this.starTagsFilter = this.starTags.filter((tag) => {
        return !this.newTagName || tag.name.toLowerCase().indexOf(this.newTagName.toLowerCase()) !== -1
      })
      this.tagsRecommendFilter = this.tagsRecommend.filter((tag) => {
        return !this.newTagName || tag.name.toLowerCase().indexOf(this.newTagName.toLowerCase()) !== -1
      })
      this.tagChooseRecommendIndex = 0
      this.tagChooseLocalIndex = 0
    },
    /**
     * 增加tag
     */
    addTag(tag) {
      if (tag) {
        tag.hasChoose = true
        this.tagSelected.push(tag)
      } else if (this.tagChooseLocalIndex > 0) {
        tag = this.starTagsFilter[this.tagChooseLocalIndex - 1]
        tag.hasChoose = true
        this.tagSelected.push(tag)
      } else if (this.tagChooseRecommendIndex > 0) {
        tag = this.tagsRecommendFilter[this.tagChooseRecommendIndex - 1]
        tag.hasChoose = true
        this.tagSelected.push(tag)
      } else if (this.newTagName) {
        const newTag = {
          name: this.newTagName,
          type: 'new',
          hasChoose: true,
        }
        this.tagSelected.push(newTag)
        this.starTags.unshift(newTag)
        // this.$nextTick(() => {
        //   this.$refs.list.scrollTop = this.$refs.list.scrollHeight
        // })
      } else {
        this.editStarTag()
      }
      // this.tagChooseLocalIndex = 0
      // this.tagChooseRecommendIndex = 0
      setTimeout(() => {
        this.newTagName = ''
        this.tagsRecommendFilter = this.tagsRecommend
        this.starTagsFilter = this.starTags
        document.removeEventListener('keydown', this.chaneInputIndex)
        this.$forceUpdate()
      }, 0)
    },
    /**
     * 移除tag
     */
    delTag(tag, index) {
      if (!tag) {
        if (this.newTagName) return
        tag = this.tagSelected.pop()
      }
      if (!tag) return
      tag.hasChoose = false
      if (tag.type === 'new') {
        this.starTags = this.starTags.filter((item) => {
          return !(!item.hasChoose && item.type === 'new' && tag.name === item.name)
        })
        this.starTagsFilter = this.starTags
      }
      this.tagSelected = this.tagSelected.filter((item) => {
        return item.hasChoose
      })
      this.$forceUpdate()
    },
    /**
     * 选择tag
     */
    toggleChoseTag(tag) {
      if (tag.hasChoose) {
        this.delTag(tag)
      } else {
        this.addTag(tag)
      }
      this.inputFoucs()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/mixin.scss';
@import '@/scss/animation.scss';

.stareditpanel{
  width: 360px;
  display: flex;
  // height: 436px;
  flex-direction: column;
  background: #fff;
  // overflow: hidden;
  position: absolute;
  z-index: 100;
  border: 1px solid rgba(195, 195, 195, 0.5);
  border-radius: 8px;
  // overflow: hidden;
  // box-shadow: 0 0 14px rgba(70, 69, 69, 0.1);
  box-shadow: 0 0 14px rgba(36, 36, 36, 0.3);
  .title{
    padding: 0;
  }
  .g_panel-header{
    border-radius: 8px 8px 0 0;
    .title{
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.stareditpanel_content{
  width: 260px;
  display: flex;
  height: 410px;
  flex-direction: column;
  background: #fff;
  border-radius: 4px;
  .listw{
    flex: none;
    max-height: 260px;
    min-height: 135px;
  }
}

// list
// *************
.listw{
  height: 360px; //250
  // margin-bottom:15px;
  padding:6px 6px 0;
  animation: fadeOut 0.2s cubic-bezier(0.4, 0, 1, 1);
  position: relative;
  overflow-y: auto;
  flex: auto;
  .list-title{
    color: #929292;
    line-height: 18px;
    font-weight: normal;
    font-size: 14px;
    padding: 5px;
    margin: 0;
  }
  .tag{
    padding: 0 5px;
    line-height: 26px;
    margin-bottom: 6px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.5s ease;
    &:hover{
      background:#E5E5E5;
      .tag-add{
        opacity: 1;
      }
    }
  }
  .tag_create {
    color: #656565;
    border: 1px dashed rgb(199, 199, 199);
    margin-bottom: 11px;
    margin-left: 4px;
    margin-right: 4px;
    .icon{
      color: #2e7fff;
    }
    &:hover{
      background:#d5d5d5;
    }
  }
  .tag_create_choose{
    background:#E5E5E5;
    .tag-add{
      opacity: 1;
    }
  }
  .tag_active{
    background:#E5E5E5;
    .tag-add{
      opacity: 1;
    }
  }
  .tag-icon{
    margin-right: 10px;
    margin-top: 5px;
    float: left;
    width: 16px;
    height: 16px;
  }
  .tag-name{
    width: 160px;
    // 因为overflow：hidden，导致baseline直接在bottom
    vertical-align:top;
    font-size: 14px;
    color: #505050;
    display: inline-block;
  }
  .tag-icon-new{
    color: #8BC34A;
    font-size: 24px;
    vertical-align: middle;
    margin-left: 4px;
  }
  .toolbar-title{
    font-size: 14px;
    line-height: 24px;
  }
  .tag-add{
    float: right;
    font-size: 14px;
    margin-top: 6px;
    color: #9B9B9B;
    opacity: 0;
    transition: opacity 0.5s ease;
  }
  .tag_choose{
    opacity: 1;
  }
}

//toolbar
//*************
.toolbar{
  padding: 10px 10px 20px;
  // background-image: linear-gradient(-180deg, #FBFBFB 0%, #F1F1F1 100%);
  background: rgba(224, 224, 224, 0.37);
  // box-shadow:0 -0.5px 0 0 rgba(194,194,194,.5), 0 1px 4px 0 rgba(145,145,145,0.50), 0 1px 2px 0 rgba(192,192,192,0.50);
  border-bottom: 1px solid rgba(138, 138, 138,0.14);
}
.toolbar-title{
  line-height: 24px;
  font-size: 14px;
  color: #5D5D5D;
  margin-bottom: 8px;
}
.toolbar-tagsw{
  width: 304px;
  padding-top:3px;
  padding-right: 3px;
  min-height: 21px;
  float: left;
  background: #D9D9D9;
  border-radius: 4px;
  margin-right: 5px;
  position: relative;
  cursor: text;
}
.toolbar-tag{
  line-height: 22px;
  font-size: 14px;
  color: #fff;
  display: inline-block;
  padding: 0 7px;
  background-image: linear-gradient(-180deg, #4f94ff 2%, #317bf1 98%);
  box-shadow: 0 0 2px 0 rgba(121,121,121,0.50);
  border-radius: 4px;
  margin: 0px 0 3px 3px;
  vertical-align: top;
}
.toolbar-tag-icon{
  width: 14px;
  margin-top: 3px;
  vertical-align: top;
}
.toolbar-tag-new{
  display: inline-block;
  border-radius: 999px;
  height: 4px;
  width: 4px;
  background-color: #8BC34A;
  vertical-align: middle;
}
.toolbar-tag_github{
  background-image: linear-gradient(-180deg, #FDFDFD 4%, #F0F0F0 100%);
  box-shadow: 0 0 1px 0 rgba(194,194,194,0.50);
  border-radius: 4px;
  color: #5D5D5D;
}
.toolbar-inputw{
  // overflow: hidden;
}
.toolbar-input{
  background: transparent;
  padding: 3px 0;
  line-height: 12px;
  width: 160px;
  height: 16px;
  border:none;
  outline: none;
  margin: 0px 0 3px 3px;
  caret-color: #8E8E8E;
  display: inline-block;
  vertical-align: top;
}
.toolbar-clear{
  display: inline-block;
  margin-left: 2px;
  cursor: pointer;
}
.toolbar-inputtip{
  width: 100%;
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 200;
  transform: translate(0, 6px);
  background: rgba(248,248,248,0.7);
  box-shadow: 0 2px 8px 0 rgba(23, 23, 23,64%);
  border-radius: 4px;
  overflow: hidden;
  max-height: 150px;
}
.toolbar-inputtip-item{
  color: #4E4E4E;
   cursor: pointer;
  &:hover{
    color: #fff;
    background: rgba(53,130,251,0.86);
  }
  .tag{
    line-height: 30px;
    padding: 0 10px;
    display: flex;
    font-size: 14px;
    align-items: center;
  }
  .tag-icon{
    width: 16px;
    margin-right: 8px;
  }
}
.toolbar-inputtip-item_active{
  color: #fff;
  background: rgba(53,130,251,0.86);
}
.toolbar-confirm{
  float: left;
  background: #2E7FFF;
  border-radius: 4px;
  color: #fff;
  width: 28px;
  height: 28px;
  line-height: 28px;
  &:hover{
    background: #0C6AFF;
  }
}
.toolbar-confirm_loading{
  background: #EBEBEB;
  color: #AAAAAA;
  &:hover{
    background: #EBEBEB;
  }
}

/** bigmode **/
.bigmode{
  .listw{
    .list-title{
      font-size: 14px;
    }
    .tag{
      line-height: 26px;
      margin: 3px 0;
    }
    .tag-icon{
      width: 16px;
      height: 16px;
    }
    .tag-name{
      font-size: 14px;
    }
  }
  .toolbar-title{
    font-size: 14px;
  }
  .toolbar-tagsw{
    width: 304px;
  }
  .toolbar-tag{
    font-size: 14px;
  }
}
.darkmode{
  background: #292929;
  border: 1px solid rgb(68,67,66);
  .tag-name{
    color: #E2E2E2;
  }
  .toolbar-title{
    color: #D7D7D7;
  }
  .tag:hover{
    &:hover {
      background: #494949;
    }
  }
  .tag_active{
    background:#494949;
  }
  .tag_create {
    color: rgba($color: #fff, $alpha: 0.5);
    border: 1px dashed rgba(255,255,255,0.08);
  }
  .toolbar-input{
    color: #fff;
  }

  .tag_create_choose{
    background:#494949;
  }
  .toolbar{
    background: #404040;
    // background-image: linear-gradient(180deg, #464543 5%, #3C3B39 99%);
    box-shadow: 0 0 0 0 rgba(32,32,32,0.50);
  }
  .toolbar-tagsw{
    background: #323232;
    box-shadow: inset 0 0 2px 0 rgba(48,48,48,0.46);
  }
}
</style>
